import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(theme => ({
    tabGroup: {
        marginBottom: theme.spacing(3),
    },
    actionLine: {
        marginBottom: theme.spacing(4),

        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    actionGroup: {
        marginLeft: 'auto',
    },
}));